import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { InactivityService } from './inactivity.service';

@Component({
  selector: 'lassi-inactivity-dialog',
  imports: [MatDialogModule, MatDialogTitle, MatDialogContent, MatButtonModule],
  template: `
    <h2 mat-dialog-title class="mat-title-medium">
      <b>You have been inactive for a while</b>
    </h2>
    <mat-dialog-content>
      <p class="mat-body-medium">
        You will be logged out in {{ timeout() }} seconds
      </p>
      <button mat-button mat-dialog-close>Cancel</button>
    </mat-dialog-content>
  `,

  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InactivityDialogComponent {
  timeout = inject(InactivityService).idleTimeout;
}
